import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=fb65e048&scoped=true&"
import script from "./UserSettings.vue?vue&type=script&lang=js&"
export * from "./UserSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserSettings.vue?vue&type=style&index=0&id=fb65e048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb65e048",
  null
  
)

export default component.exports